import apiService from '@sonifi/wb-core/services/api.service';
import { parseQueryParams } from '@sonifi/wb-core/utils/parseHelper';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { DEFAULT_PARAMS } from '../constants/wbGroupConstants';
import { setGroups, setSelectedGroup } from '../store/groupsSlice';
import { GROUPS_KEYS } from '../store/groupsConstants';

const isGroupGrid = (group) =>
  group.group_type === 'property' &&
  group.market_type === 'healthcare' &&
  group.platform === 'Ocean';

export const getGroups =
  ({ params = DEFAULT_PARAMS, groupKey }) =>
  async (dispatch) => {
    try {
      const queryParams = parseQueryParams(params);
      const url = `${ENDPOINTS.GROUPS}?${queryParams}`;
      const res = await apiService.get(url);
      const groups = res.data.objects.map((group) => ({
        ...group,
        isGrid: isGroupGrid(group),
      }));
      dispatch(setGroups({ groups, groupKey }));
      return groups;
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  };

export const findGroupById = (groupId) => (_, getState) => {
  const {
    groups: { groups },
  } = getState();
  const group = groups[GROUPS_KEYS.allGroups].find(
    (g) => g.id === parseInt(groupId),
  );
  return group;
};

export const setGroupByUrl = (groupId) => (dispatch) => {
  if (groupId) {
    const group = dispatch(findGroupById(groupId));
    dispatch(setSelectedGroup(group));
  }
};
